import { makeRequest } from 'utils/requestLogger';

export default (roundtable_id) =>
  makeRequest('get', `/api/roundtables/${roundtable_id}/summary`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/grades/classSummary.js